import React, { createContext, useContext, useEffect, useState } from 'react';
import {
  Stat,
  StatLabel,
  StatNumber,
  StatHelpText,
  StatArrow,
  StatGroup,
  Card,
  useColorModeValue,
  CardBody,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Spinner,
  Image,
  Text,
  Box,
} from '@chakra-ui/react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
const ContentPage = () => {
  useEffect(() => {
    const fetchData = async () => {
      try {
        //setVerify("none");
        await fetchFollowerCount();
      } catch (error) {
        console.error(error);
      } finally {
        // setRefreshing(false); // Ensure refreshing is set to false after the data fetching
      }
    };

    fetchData();
    return () => {
      // cleanup logic if needed
    };
  }, []);

  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [videosLoading, setvideosLoading] = useState(true);

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        setvideosLoading(true);
        const token = await localStorage.getItem('accessToken');

        const response = await fetch('https://api.wipe.wtf/videos', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch videos');
        }

        const videosJson = await response.json();
        setVideos(videosJson);

        await localStorage.setItem('videos', JSON.stringify(videosJson));
      } catch (error) {
        console.error('Error fetching videos:', error);
        setvideosLoading(false);
      } finally {
        setLoading(false);
        setvideosLoading(false);
      }
    };

    fetchVideos();
  }, []);
  const bgColor = useColorModeValue('#f0eded', '#0f0f0f');
  const textColor = useColorModeValue('#333', '#fff');
  const headerColor = useColorModeValue('#444', '#bbb');
  const tableTextColor = useColorModeValue('#111', '#ddd');
  const boxShadowColor = useColorModeValue(
    '0 2px 5px rgba(0, 0, 0, 0.1)',
    '0 2px 5px rgba(255, 255, 255, 0.1)'
  );
  const imageBorderColor = useColorModeValue('#ddd', '#333');

  const fetchFollowerCount = async () => {
    try {
      const logedinuser = await localStorage.getItem('logedinuser');
      const response = await fetch(
        `https://api.wipe.wtf/followers/${logedinuser}/count`
      );
      const data = await response.json();
      setFollowerCount(data.followerCount);
    } catch (error) {
      console.log(error);
    }
  };
  const [followerCount, setFollowerCount] = React.useState('Loading...');

  return (
    <div style={{ padding: 12 }}>
      <Card
        bg={bgColor}
        style={{
          borderRadius: 15,
          marginTop: 0,
          boxShadow: useColorModeValue(
            '0 4px 6px rgba(0, 0, 0, 0.1)',
            '0 4px 6px rgba(255, 255, 255, 0.1)'
          ),
          padding: '10px',
        }}
      >
        <CardBody>
          <Text
            style={{
              fontWeight: 'bold',
              fontSize: 20,
              marginBottom: '10px',
              color: textColor,
            }}
          >
            Your Content:
          </Text>
          <TableContainer>
            <Table variant="simple">
              <Thead>
                <Tr>
                  <Th color={headerColor} fontWeight="700">
                    Video:
                  </Th>
                  <Th color={headerColor} fontWeight="700">
                    Likes:
                  </Th>
                  <Th color={headerColor} fontWeight="700">
                    Dislikes:
                  </Th>
                  <Th color={headerColor} fontWeight="700">
                    Views:
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {videosLoading
                  ? // Skeleton loader while videos are loading
                    Array(5)
                      .fill()
                      .map((_, index) => (
                        <Tr key={index}>
                          <Td>
                            <Box display="flex" alignItems="center">
                              <Skeleton
                                width={75}
                                height={110}
                                style={{
                                  borderRadius: 10,
                                  marginRight: '20px',
                                }}
                              />
                              <Box>
                                <Skeleton width={100} height={20} />
                              </Box>
                            </Box>
                          </Td>
                          <Td>
                            <Skeleton width={20} height={20} />
                          </Td>
                          <Td>
                            <Skeleton width={20} height={20} />
                          </Td>
                          <Td>
                            <Skeleton width={20} height={20} />
                          </Td>
                        </Tr>
                      ))
                  : videos.map((video, index) => (
                      <Tr key={index}>
                        <Td>
                          <Box display="flex" alignItems="center">
                            <Image
                              src={`https://api.wipe.wtf/thumbnails/${video.thumbnail}`}
                              width={75}
                              height={110}
                              mr={5}
                              onClick={() =>
                                window.open(
                                  `https://cdn.wipe.wtf/video-stream/${video.filename}`,
                                  '_blank'
                                )
                              }
                              objectFit="cover"
                              borderRadius={10}
                              style={{
                                border: `2px solid ${imageBorderColor}`,
                                boxShadow: boxShadowColor,
                              }}
                            />
                            <Box>
                              <Text fontWeight="500" color={textColor}>
                                {video.Name}
                              </Text>
                            </Box>
                          </Box>
                        </Td>
                        <Td color={tableTextColor}>{video.Likes}</Td>
                        <Td color={tableTextColor}>{video.Dislikes}</Td>
                        <Td color={tableTextColor}>
                          {video.Likes + video.Dislikes}
                        </Td>
                      </Tr>
                    ))}
              </Tbody>
            </Table>
          </TableContainer>
        </CardBody>
      </Card>
    </div>
  );
};

export default ContentPage;
